import React, { useEffect, useState } from 'react';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { useHistory } from "react-router-dom";
import { Modal, Button, Space, Checkbox, Radio } from 'antd';
import CommingSoon from '../../container/commingsoon';
import { postRequest } from '../../Utils/AppApi';
import { POST_SEND_MATM_OFFER_API } from '../../Utils/appConstants';
import { toast } from 'react-toastify';

function AgentDashboard(props) {
  const history = useHistory();
  const [isMatchCheckbox, setMatchCheckbox] = useState(false);
  const [ecollect, setEcollect] = useState(false);
  const [commingSoon, setCommingSoon] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  // const [showService, setShowService] = useState(false);
  const [isMatmModal, setMatmModal] = useState(false);
  const [isProductName, setProductName] = useState("Combo");
  const [isProductAmount, setProductAmount] = useState("4200");

  const serviceOption = [{
    value: 'Combo',
    label: 'Combo',
    amount: '4200',
  }, {
    value: 'Mantra L1',
    label: 'Mantra L1',
    amount: '3200',
  }, {
    value: 'MATM (Morefun MP63)',
    label: 'MATM (Morefun MP63)',
    amount: '1800',
  }]
  const handleOpenECollectClose = () => {
    setEcollect(false);
  }

  const handleOpenClose = () => {
    setCommingSoon(false)
  }

  const onChangeChackBox = (e) => {
    // console.log("e.target.checked -------------", e.target.checked)
    setMatchCheckbox(e.target.checked)
  };

  const handleSizeChange = ({ target: { value } }) => {
    let data = serviceOption.filter((items) => items.value === value);
    // console.log("e.target.checked -------------", data[0].amount)
    setProductName(value);
    setProductAmount(data[0].amount);
  };

  const sendBuyOffer = () => {
    let payload = {
      quantity: 1,
      amount: isProductAmount,
      product: isProductName,
      comment: ""
    }
    postRequest(POST_SEND_MATM_OFFER_API, payload, history).then((response) => {
      if (response.success === true) {
        setMatchCheckbox(false);
        setMatmModal(false);
        toast.success(response.message);
      } else {
        setMatmModal(false);
        toast.error(response.message);
      }
    }).catch(function (error) {
      setMatmModal(false);
      console.log(error)
      // setLoading(false);
    })
  }

  useEffect(() => {
    // console.log("props.userData.data -------------", props.userData.data)
    if (props.userData || !userProfile) {
      setUserProfile(props.userData.data)
    }
    if (userProfile && userProfile.kycStatus === 3) {
      // setShowService(true)
    }
  }, [userProfile]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="content pt-3">
        <div className="container-fluid pb-5 five-xl-col">
          <div className="row">
            <div className="col-sm-6 col-md-4 col-lg-4 mt-50" onClick={() => history.push({ pathname: "/request-money" })}>
              <div className='dbox-outer'>
                <div className='dbox-cols'>
                  {/* <div className='pr-2 dbox-icon'><img src='../images/money-icon.svg' alt='icon' /></div> */}
                  <div className='dbox-text2 font14'>
                    Request Money
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 mt-50" onClick={() => history.push({ pathname: "/payment-deposit" })}>
              <div className='dbox-outer'>
                <div className='dbox-cols'>
                  {/* <div className='pr-2 dbox-icon'><img src='../images/payment-gateway.svg' alt='icon' /></div> */}
                  <div className='dbox-text2 font14'>
                    Payment Deposit
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 mt-50" onClick={() => history.push({ pathname: "/channel-wallet-ledger" })}>
              <div className='dbox-outer'>
                <div className='dbox-cols'>
                  {/* <div className='pr-2 dbox-icon'><img src='../images/payment-gateway.svg' alt='icon' /></div> */}
                  <div className='dbox-text2 font14'>
                    Channel Wallet Ledger
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {ecollect && (<Modal
        open={ecollect}
        onCancel={() => handleOpenECollectClose()}
        footer={false}
      >
        <Space
          direction="vertical"
          style={{
            width: '100%',
          }}
          className='mt-20'
        >
          <a target='_blank' rel="noreferrer" href='https://www.onlinesbi.sbi/sbicollect/icollecthome.htm?corpID=856614'><Button type="primary" block> SBI Collect </Button></a>
          <Button type="primary" block> PNB Collect </Button>
          <Button type="primary" block> UNION Collect </Button>
        </Space>
      </Modal>)
      }

      {commingSoon && (<Modal
        open={commingSoon}
        onCancel={() => handleOpenClose()}
        footer={false}
        width={"500px"}
      >
        <CommingSoon />
      </Modal>)
      }

      {isMatmModal && (<Modal
        open={isMatmModal}
        onCancel={() => setMatmModal(false)}
        okText={"Confirm"}
        onOk={() => sendBuyOffer()}
        okButtonProps={{ disabled: !isMatchCheckbox }}
        width={500}
      >
        <div className="col-md-6 col-lg-12 mb-1">
          <img src='../../festival/offer.jpeg' width={"540"} alt='' />
          <div className="row">
            <div className='col-md-12 form-group mt-3'>
              <Radio.Group options={serviceOption} value={isProductName} buttonStyle="solid" optionType="button" onChange={handleSizeChange}>
              </Radio.Group>
            </div>
          </div>
          <Checkbox className="mr-2" onChange={onChangeChackBox} /><p className="mt-2 text-primary pl-3">I hereby confirm that i accept the SRPAY MATM Combo offer wroth Rs. {isProductAmount}.</p>
          <strong>Note :- <span className="text-danger">Once the Product is purchased amount is not refundable.</span></strong>
        </div>
      </Modal>)
      }
    </div>
  );
}

export default AgentDashboard;